import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { imgUrl } from "@/lib/api";

const FRAMES = [
  {
    key: "tea-table",
    image: "/api/uploads/community/grown-ups/tea-table.webp",
    caption: "Six friends. One tea table. A garden turning gold.",
  },
  {
    key: "picnic",
    image: "/api/uploads/community/grown-ups/picnic.webp",
    caption: "Tea, laugh, repeat.",
  },
  {
    key: "pathway",
    image: "/api/uploads/community/grown-ups/pathway.webp",
    caption: "Sunbeams and jasmine, all six in a row.",
  },
  {
    key: "friends-walk",
    image: "/api/uploads/community/grown-ups/friends-walk.webp",
    caption: "The garden walk after the tea's gone cold.",
  },
];

const GrownupsBand = () => {
  const [i, setI] = useState(0);
  const [paused, setPaused] = useState(false);
  useEffect(() => {
    if (paused) return;
    const t = setInterval(() => setI((n) => (n + 1) % FRAMES.length), 4500);
    return () => clearInterval(t);
  }, [paused]);
  const cur = FRAMES[i];

  return (
    <section
      className="relative w-full my-24 md:my-32"
      onMouseEnter={() => setPaused(true)}
      onMouseLeave={() => setPaused(false)}
      data-testid="grownups-band"
    >
      <div className="relative w-full overflow-hidden bg-charcoal" style={{ aspectRatio: "16 / 9", maxHeight: 720 }}>
        {FRAMES.map((f, idx) => (
          <img
            key={f.key}
            src={imgUrl(f.image)}
            alt={f.caption}
            className="absolute inset-0 w-full h-full object-cover transition-opacity duration-[1400ms]"
            style={{ opacity: idx === i ? 1 : 0 }}
            data-testid={`grownups-slide-${f.key}`}
          />
        ))}
        {/* left-side ivory wash so headline reads */}
        <div className="absolute inset-0" style={{
          background: "linear-gradient(90deg, rgba(28,26,25,0.55) 0%, rgba(28,26,25,0.25) 30%, rgba(28,26,25,0) 55%)"
        }} />
        <div className="grain absolute inset-0 opacity-40" />

        <div className="relative z-10 h-full flex items-end">
          <div className="max-w-[1440px] mx-auto px-6 md:px-12 lg:px-24 pb-12 md:pb-16 w-full">
            <div className="max-w-[520px] text-ground">
              <div className="nav-item mb-4 text-ground/75">Grown-ups</div>
              <h2 className="serif text-4xl md:text-6xl leading-[1.02]">
                Small clothes, <em className="italic">bigger circles</em>.
              </h2>
              <p className="mt-5 max-w-[42ch] text-sm md:text-base leading-relaxed text-ground/85">
                Women&rsquo;s pieces in the same palette as the children&rsquo;s line — hand-dyed, hand-embroidered,
                made in the same small batches on the same table.
              </p>
              <div className="mt-6 flex flex-wrap items-center gap-6">
                <Link to="/adults" className="inline-block px-6 py-3 rounded-full text-[11px] tracking-[0.22em] uppercase border border-ground text-ground hover:bg-ground hover:text-ink transition-colors" data-testid="grownups-cta">
                  Enter the adults' shop
                </Link>
                <span className="text-[11px] tracking-[0.2em] uppercase text-ground/60">{cur.caption}</span>
              </div>
              <div className="mt-6 flex gap-2" data-testid="grownups-dots">
                {FRAMES.map((f, idx) => (
                  <button
                    key={f.key}
                    onClick={() => setI(idx)}
                    aria-label={f.caption}
                    className={`h-1 transition-all ${idx === i ? "w-10 bg-ground" : "w-6 bg-ground/30 hover:bg-ground/60"}`}
                    data-testid={`grownups-dot-${f.key}`}
                  />
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default GrownupsBand;
